// import React, { useMemo } from 'react'
import React, { useMemo } from 'react'
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import useSWR from 'swr'
// import { DatasourceProps } from '../Input.types'

// const useDatasource = (dataSourceProps: DatasourceProps, searchQuery = '') => {
//     return {
//         data: [],
//     }
// }

const useDatasource = (dataSourceProps, searchQuery = '', runQuery = true) => {
    if (!dataSourceProps) {
        return {}
    }

    let data
    let mutate
    let error = false
    let isValidating = false
    let isLoading = undefined
    // If data is passed to useDatasource then no remote call is necessary.
    if (Array.isArray(dataSourceProps)) {
        data = { data: dataSourceProps }
    } else if (typeof dataSourceProps === 'function') {
        return dataSourceProps(searchQuery)
    } else if (dataSourceProps.url) {
        const { method, url, body } = dataSourceProps
        const _instance = axios.create()

        const constructUrl = (_searchQuery, _url) => {
            if (typeof _url === 'function') {
                return _url(_searchQuery)
            }
            return _url
        }

        const constructBody = (_searchQuery, _body) => {
            if (_searchQuery === null || _body === undefined) {
                return null
            }
            if (typeof _body === 'function') {
                return _body(_searchQuery)
            }
            return _body
        }

        const constructedUrl = useMemo(() => constructUrl(searchQuery, url), [searchQuery, url])
        const constructedBody = useMemo(() => constructBody(searchQuery, body), [searchQuery, body])

        // console.log('CONTRSUSCT', constructedUrl)
        const fetcher = (key) => {
            const req: any = { method, url: constructedUrl }

            if (method === 'POST' || method === 'PUT') {
                req.body = constructedBody
            }

            return _instance(req)
        }

        const shouldfetch = runQuery ? constructedUrl : null
        const swr = useSWR(shouldfetch, fetcher, {
            onSuccess: (res) => {
                if (dataSourceProps.onSuccess) {
                    dataSourceProps.onSuccess(res)
                }
            },
        })
        data = swr.data
        mutate = swr.mutate
        error = swr.error
        isValidating = swr.isValidating
    } else {
        data = { data: dataSourceProps }
    }

    // console.log('Usedatasource', data)

    return {
        data: data ? data.data : undefined,
        error,
        isValidating,
        isLoading: runQuery && !data && !error,
    }
}

export default useDatasource
